module.exports = __webpack_public_path__ + "static/media/java_logo.459bbae2.svg";